module.exports = __webpack_public_path__ + "static/gnome-female-AYAGWW-73407b7adf4afce59e0cc43d6ae58389.png";